const axios = require("axios");

export default axios;
